import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDuWCBTrmr3M7KyB5s-WqrcmyC5gMAXGUI",
  authDomain: "nuhpulnuhpul-e070b.firebaseapp.com",
  projectId: "nuhpulnuhpul-e070b",
  storageBucket: "nuhpulnuhpul-e070b.firebasestorage.app",
  messagingSenderId: "535406690905",
  appId: "1:535406690905:web:6987aadd8b0d357b7ee748"
};

const app = initializeApp(firebaseConfig);

export const db      = getFirestore(app);
export const auth    = getAuth(app);
export const storage = getStorage(app);
